import './NoDataSelected.scss';
import SearchData from '../../../resources/icons/search-data.svg?react';

type Props = {
  GraphComponent?: any;
  className?: string;
};

function NoDataSelected({ GraphComponent = SearchData, className }: Props) {
  return (
    <div className={`no-data-selected fs--b-base ${className}`}>
      <GraphComponent />
      <p className="fs--b-base">No data selected</p>
    </div>
  );
}

export default NoDataSelected;
